import Vue from "vue"
import { Component } from "vue-property-decorator"
import { $refs } from "@/implements/implementRefs"

@Component({})
export class mixinImplementRef extends Vue implements $refs {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $refs: any

  ref (key: string, next?: (arg0: () => $refs) => void): $refs | unknown {
    const INPUT_REF = key && this.$refs[key] as {
      id?: string;
    }

    const EXIST_INPUT_REF = INPUT_REF ? (INPUT_REF[0] || INPUT_REF) : {}
    const {
      id: INPUT_REF_ID,
    } = EXIST_INPUT_REF

    if (INPUT_REF_ID) {
      if (next) {
        return next(EXIST_INPUT_REF) as unknown as $refs
      } else {
        return EXIST_INPUT_REF
      }
    }
  }
}
